import { graphql } from "@/data-access/graphql";

export const MeFeedLastLocationFragment = graphql(`
  fragment MeFeedLastLocationFragment on FeedLastLocationType @_unmask {
    feedId
    surface
    location
    updatedAt
  }
`);

export const MeTenantFragment = graphql(`
  fragment MeTenantFragment on TenantType @_unmask {
    id
    name
    slug
    website
    activeLicenseTypes
    logo {
      url
    }
    owner {
      id
    }
  }
`);

export const MeUserFragment = graphql(
  `
    fragment MeUserFragment on UserType @_unmask {
      id
      email
      name
      lastVisitedLocation
      feedLastLocations {
        ...MeFeedLastLocationFragment
      }
      avatar {
        url
      }
    }
  `,
  [MeFeedLastLocationFragment],
);
